// import React, { useState } from "react";
// import { Input, FormFeedback, Tooltip } from "reactstrap";

// const EmailInput = ({
//     label = "Email", 
//     placeholder = "Enter your email",
//     required = false, 
//     layout = "below", // Default layout (inline or below)
//     value = "", 
//     name = "email", 
//     id = "emailInput", 
//     onChange = () => {}, 
//     onBlur = () => {},
//     requiredErrorMessage = "Email is required.", 
//     validationErrorMessage = "Please enter a valid email address.", 
//     businessEmailErrorMessage = "Only business emails are allowed.",
//     showHelp = false, 
//     helpText = "Please enter your email.", 
//     businessEmailOnly = false,
// }) => {
//     const [inputValue, setInputValue] = useState(value); 
//     const [errors, setErrors] = useState({}); 
//     const [tooltipOpen, setTooltipOpen] = useState(false);

//     // Email validation function
//     const validateEmail = (value) => {
//         const newErrors = {};

//         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         const businessEmailRegex = /^[^\s@]+@(?!gmail\.com|yahoo\.com|hotmail\.com)[^\s@]+\.[^\s@]+$/;

//         // Only validate 'required' if the field is marked as required
//         if (required && !value) {
//             newErrors.required = requiredErrorMessage;
//         } else if (value && (value.length < 5 || !emailRegex.test(value))) {
//             newErrors.validation = validationErrorMessage;
//         } else if (businessEmailOnly && !businessEmailRegex.test(value)) {
//             newErrors.validation = businessEmailErrorMessage;
//         }

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0; // Return true if no errors
//     };

//     // Handle input change
//     const handleInputChange = (e) => {
//         const newValue = e.target.value;
//         setInputValue(newValue); 
//         validateEmail(newValue); 
//         onChange(e); 
//     };

//     // On blur, validate the input
//     const handleInputBlur = (e) => {
//         validateEmail(e.target.value);
//         onBlur(e); 
//     };

//     return (
//         <div className={layout === "inline" ? "d-flex align-items-center" : ""}>
//             <label htmlFor={id} className="d-flex" style={{ width: layout === "inline" ? "20%" : "100%" }}>
//                 {label}
//                 {required && <span className="text-danger ml-1">*</span>} 
//                 {showHelp && (
//                     <span id="helpTooltip" className="px-2">
//                         <i
//                             className="ri-question-line"
//                             style={{ cursor: 'pointer', fontSize: '16px' }}
//                         ></i>
//                     </span>
//                 )}
//             </label>
//             {showHelp && (
//                 <Tooltip
//                     placement="right"
//                     isOpen={tooltipOpen}
//                     target="helpTooltip"
//                     toggle={() => setTooltipOpen(!tooltipOpen)}
//                 >
//                     {helpText}
//                 </Tooltip>
//             )}
//             <div className="w-100">
//                 <Input
//                     type="email"
//                     name={name} 
//                     id={id} 
//                     placeholder={placeholder}
//                     value={inputValue}
//                     onChange={handleInputChange} 
//                     onBlur={handleInputBlur}
//                     invalid={!!errors.required || !!errors.validation}
//                 />

//                 {errors.required && (
//                     <FormFeedback type="invalid">
//                         {errors.required}
//                     </FormFeedback>
//                 )}
//                 {errors.validation && (
//                     <FormFeedback type="invalid">
//                         {errors.validation}
//                     </FormFeedback>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default EmailInput;














import React, { useState, useEffect } from "react";
import { Input, FormFeedback, Tooltip } from "reactstrap";

const EmailInput = ({
    label = "Email",
    placeholder = "Enter your email",
    required = false,
    layout = "below",
    value = "",
    name = "email",
    id = "emailInput",
    onChange = () => { },
    onBlur = () => { },
    requiredErrorMessage = "Email is required.",
    validationErrorMessage = "Please enter a valid email address.",
    businessEmailErrorMessage = "Only business emails are allowed.",
    showHelp = false,
    helpText = "Please enter your email.",
    businessEmailOnly = false,
    validateTrigger = false,
    disabled = false,
}) => {
    const [inputValue, setInputValue] = useState(value);
    const [errors, setErrors] = useState({});
    const [tooltipOpen, setTooltipOpen] = useState(false);

    useEffect(() => {
        setInputValue(value);
    }, [value])

    useEffect(() => {
        if (validateTrigger) {
            validateEmail(inputValue);
        }
    }, [validateTrigger]);

    const validateEmail = (value) => {
        const newErrors = {};

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const businessEmailRegex = /^[^\s@]+@(?!gmail\.com|yahoo\.com|hotmail\.com)[^\s@]+\.[^\s@]+$/;

        if (required && !value) {
            newErrors.required = requiredErrorMessage;
        } else if (value && (value.length < 5 || !emailRegex.test(value))) {
            newErrors.validation = validationErrorMessage;
        } else if (businessEmailOnly && !businessEmailRegex.test(value)) {
            newErrors.validation = businessEmailErrorMessage;
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        if (!disabled) {
            const newValue = e.target.value;
            setInputValue(newValue);
            validateEmail(newValue);
            onChange(e);
        }
    };

    const handleInputBlur = (e) => {
        validateEmail(e.target.value);
        onBlur(e);
    };

    return (
        <div className={layout === "inline" ? "d-flex align-items-center" : ""}>
            <label htmlFor={id} className="d-flex" style={{ width: layout === "inline" ? "20%" : "100%" }}>
                {label}
                {required && <span className="text-danger ml-1">*</span>}
                {showHelp && (
                    <span id="helpTooltip" className="px-2">
                        <i className="ri-question-line" style={{ cursor: "pointer", fontSize: "16px" }}></i>
                    </span>
                )}
            </label>
            {showHelp && (
                <Tooltip placement="right" isOpen={tooltipOpen} target="helpTooltip" toggle={() => setTooltipOpen(!tooltipOpen)}>
                    {helpText}
                </Tooltip>
            )}
            <div className="w-100">
                <Input
                    type="email"
                    name={name}
                    id={id}
                    placeholder={placeholder}
                    value={inputValue}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                    invalid={!!errors.required || !!errors.validation}
                    disabled={disabled}
                />
                {errors.required && <FormFeedback type="invalid">{errors.required}</FormFeedback>}
                {errors.validation && <FormFeedback type="invalid">{errors.validation}</FormFeedback>}
            </div>
        </div>
    );
};

export default EmailInput;
